import { Stands } from '../Stands';

export const daData = {
	[Stands.test]:
		'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
	[Stands.cert]:
		'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
	[Stands.prod]:
		'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
};
